'use client';

/**
 * SignupBannerButton Component
 * 
 * A client component button for the signup banner that smoothly scrolls to the contact section.
 * Styled with white background and black text for visibility on black banner background.
 */

import { ArrowRightIcon } from '@heroicons/react/24/outline';

export default function SignupBannerButton() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <button
      onClick={scrollToContact}
      className="bg-white hover:bg-gray-100 text-gray-900 font-poppins font-semibold px-6 py-3 lg:px-8 lg:py-4 text-base lg:text-lg rounded transition-colors duration-200 inline-flex items-center gap-2 whitespace-nowrap"
    >
      <span>Get Started</span>
      <ArrowRightIcon className="w-4 h-4 lg:w-5 lg:h-5" />
    </button>
  );
}

